/**
 * Custom SectionHero for ConstructionYardSale.com
 * Receives same props as default SectionHero (Console data),
 * renders with the industrial construction theme.
 */
import React from 'react';

import Field, { hasDataInFields } from '../../Field';
import SectionContainer from '../SectionContainer';

const SectionHeroCustom = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div
        style={{
          position: 'relative',
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Gradient overlay for readability */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, hsl(0 0% 98%), hsl(0 0% 98% / 0.9), transparent)',
            pointerEvents: 'none',
          }}
        />

        <div
          style={{
            position: 'relative',
            zIndex: 10,
            textAlign: 'center',
            padding: '2rem 1rem',
            maxWidth: '48rem',
            margin: '0 auto',
          }}
        >
          {/* Badge */}
          <div
            style={{
              display: 'inline-block',
              marginBottom: '0.75rem',
              padding: '0.25rem 0.75rem',
              backgroundColor: 'hsl(45 93% 47%)',
              color: 'hsl(0 0% 9%)',
              fontSize: '0.75rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              borderRadius: '2px',
            }}
          >
            The #1 P2P Construction Marketplace
          </div>

          {hasHeaderFields ? (
            <header>
              <Field
                data={title}
                className={defaultClasses?.title}
                options={fieldOptions}
              />
              <Field
                data={description}
                className={defaultClasses?.description}
                options={fieldOptions}
              />
              <Field
                data={callToAction}
                className={defaultClasses?.ctaButton}
                options={fieldOptions}
              />
            </header>
          ) : (
            <header>
              <h1
                style={{
                  fontFamily: "'Oswald', sans-serif",
                  fontSize: 'clamp(1.75rem, 4vw, 3rem)',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '-0.025em',
                  marginBottom: '1rem',
                  color: 'hsl(0 0% 9%)',
                }}
              >
                Don't Dump It.{' '}
                <span style={{ color: 'hsl(25 95% 53%)' }}>Sell It.</span>
              </h1>
              <p
                style={{
                  fontSize: '1.125rem',
                  color: 'hsl(0 0% 30%)',
                  fontWeight: 500,
                  marginBottom: '1rem',
                }}
              >
                Buy and sell used leftover construction materials and equipment locally.
              </p>
            </header>
          )}
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionHeroCustom;
